import { DeployLayout } from "@/components/organisms/deployment/DeployLayout";

export function Deploy() {
  return (
    <div className="flex h-full flex-col">
      <DeployLayout />
    </div>
  );
}

export default Deploy;
